import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * id (name) of the checkbox group
   */
  id: PropTypes.string.isRequired,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * options of the checkbox group
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string, // option value needs to be an string!
    }),
  ).isRequired,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Selected values
   */
  value: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
   * validation errors messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
  /**
   * Indicates if field is required
   */
  required: PropTypes.bool,
}

function CheckboxGroup(props) {
  const {
    id,
    title = null,
    options,
    onChange,
    value = [],
    errors = [],
    titleClassName = '',
    required = false,
    ...rest
  } = props ?? {}

  return (
    <div className="mb-3">
      {title && (
        <p className={clsx('mb-2', titleClassName)}>
          <FormattedMessage id={title} />
          {required && <span className="font-size-regular text-color-danger">*</span>}
        </p>
      )}

      {options.map((option) => (
        <Form.Check
          {...rest}
          key={option.value}
          custom
          type="checkbox"
          name={id} // in a checkbox group all checkboxes should have the same name
          id={option.value} // options values are mapped as the checkbox id and value
          value={option.value}
          checked={value?.includes(option.value) ?? false}
          label={option.label}
          onChange={onChange}
        />
      ))}

      {errors?.map((errorMessage) => (
        <div key={errorMessage} className="text-color-danger mt-2">
          {errorMessage}
        </div>
      ))}
    </div>
  )
}

CheckboxGroup.propTypes = propTypes

export default CheckboxGroup
